import { createAsyncThunk } from '@reduxjs/toolkit'

import { ITypeTicketCollectionData } from 'meta/pages/v4/typeticketcollection'
import { TypeTicketCollectionController } from 'controller/typeticketcollection'

type Returned = ITypeTicketCollectionData[]

type Props = {
  ids: number[]
  eventId?: number
}

export const getBulkData = createAsyncThunk<Returned, Props>('pages/typeticketcollection/bulk', async (props) => {
  const { ids, eventId } = props

  const data = await TypeTicketCollectionController.getBulkData({ ids })

  if (eventId) {
    return data.items.map((x) => {
      return { ...x, eventId: eventId }
    })
  }

  return data.items
})
